import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/** Routes that require Jira Administrator–style project delete permission. */
export const deleteProjectGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.canDeleteProject()) return true;
  return router.createUrlTree(['/projects']);
};
